import {Component, effect, OnInit, Output, signal} from '@angular/core';
import {AuthOtpComponent} from "@app/areas/auth/component/auth-otp/auth-otp.component";
import {AppAuthService} from "@services/core/auth/app-auth.service";

import {ButtonComponent} from "@shared/components/buttons/button/button.component";
import {take} from "rxjs/operators";
import {
  AppointmentCallModalComponent
} from "@app/areas/appointments/components/appointment-call-modal/appointment-call-modal.component";
import {OtpAuthService} from "@app/areas/auth/services/otp-auth.service";
import {AppointmentApiService} from "@app/areas/appointments/services/appointment-api.service";
import moment from "moment-timezone";
import {AppointmentDetail} from "@app/areas/appointments/models/appointment.interface";
import {AlertService} from "@services/helpers/alert/alert.service";
import {LocalizeService} from "@services/helpers/localize/localize.service";
import {LocalizedDatePipe} from "@shared/pipes/localized-date/localized-date.pipe";
import {LocalizeTextPipe} from "@shared/pipes/localize-text/localize-text.pipe";
import {CardComponent} from "@shared/components/cards/card/card.component";
import {FormsModule} from "@angular/forms";
import {IconComponent} from "@shared/components/icon/icon.component";

@Component({
  selector: 'app-consultation-invite',
  imports: [
    AuthOtpComponent,
    ButtonComponent,
    AppointmentCallModalComponent,
    LocalizedDatePipe,
    LocalizeTextPipe,
    CardComponent,
    FormsModule,
    IconComponent
],
  templateUrl: './consultation-invite.component.html',
  styleUrl: './consultation-invite.component.scss',
  standalone: true
})
export class ConsultationInviteComponent implements OnInit {
  appointmentId$ = signal<string | null>(null)
  appts$ = signal<AppointmentDetail[]>([])
  loadingAppts$ = signal(false)

  participant$ = signal<any | null>(null)
  loadingParticipant$ = signal(false)
  loadingParticipantUpdate$ = signal(false)

  firstName$: string | null = null;
  lastName$: string | null = null;

  constructor(
    private api: AppointmentApiService,
    public auth: OtpAuthService,
    private alert: AlertService,
    private l: LocalizeService
  ) {
    effect(() => {
      const p = this.participant$();
      this.firstName$ = p?.firstName ?? null
      this.lastName$ = p?.lastName ?? null
    });
  }

  ngOnInit(): void {
    this.refreshAppointments()
    this.refreshParticipant()
  }

  refreshParticipant(): void {
    this.loadingParticipant$.set(true)
    this.api.getParticipant()
      .pipe(take(1))
      .subscribe({
        next: res => {
          this.loadingParticipant$.set(false)
          this.participant$.set(res)
        },
        error: err => {
          console.log('err', err)
          this.alert.error(this.l.l('LoadParticipant.Failed', 'There was an error loading your profile details.'))
          this.loadingParticipant$.set(false)
        }
      })
  }

  handleOtpToken(payload: { token: string, phoneNumber: string }): void {
    console.log('handleOtpToken', payload)

    this.auth.loginOtp(payload.token)
      .pipe(take(1))
      .subscribe({
        next: res => {
          console.log('Logged in via OTP successfully.')
          this.refreshAppointments();
          this.refreshParticipant();
        },
        error: err => {
          console.error('Could not login via OTP:')
          console.error(err)
        }
      })
  }

  refreshAppointments(): void {
    const start = moment().startOf('day').utc()
    const end = moment().endOf('day').utc()

    this.loadingAppts$.set(true)
    this.api.list(start.format(), end.format())
      .pipe(take(1))
      .subscribe({
        next: res => {
          this.loadingAppts$.set(false)
          this.appts$.set(res)
        },
        error: err => {
          console.log('err', err)
          this.alert.error(this.l.l('LoadAppointments.Failed', 'There was an error loading your appointments.'))
          this.loadingAppts$.set(false)
        }
      })
  }

  updateParticipant(): void {
    console.log('update')
    this.loadingParticipantUpdate$.set(true)
    this.api.updateParticipant(this.firstName$, this.lastName$)
      .pipe(take(1))
      .subscribe({
        next: res => {
          this.alert.success(this.l.l('ParticipantUpdate.Success', 'Your details were saved successfully.'))
          this.loadingParticipantUpdate$.set(false)
        },
        error: err => {
          this.alert.error(this.l.l('ParticipantUpdate.Error', 'There was an issue updating your details, please try again.'))
          this.loadingParticipantUpdate$.set(false)
        }
      })
  }
}
